export enum PayTableConditionName {
  CHERRY_TOP = 'CHERRY_TOP',
  CHERRY_CENTER = 'CHERRY_CENTER',
  CHERRY_BOTTOM = 'CHERRY_BOTTOM',
  SEVEN_ANY = 'SEVEN_ANY',
  CHERRY_OR_SEVEN_ANY = 'CHERRY_OR_SEVEN_ANY',
  BAR3_ANY = 'BAR3_ANY',
  BAR2_ANY = 'BAR2_ANY',
  BAR_ANY = 'BAR_ANY',
  BARS_ANY = 'BARS_ANY',
}